import dynamic from 'next/dynamic';
import A from './components/US/A';
import B from './components/US/B';
import D from './components/US/D';
import E from './components/US/E';
import F from './components/US/F';
import H from './components/US/H';
import J from './components/US/J';
import EfScrollAni from '@/efscrollani';
import './components/US/index.scss';
import ForumEntry from '@elem/compCommon/CommunityEntry';
// import PDBar from '@elem/compCommon/PDBar';
const C = dynamic(() => import('./components/US/C'), { ssr: false });
const G = dynamic(() => import('./components/US/G'), { ssr: false });
const I = dynamic(() => import('./components/US/I'), { ssr: false });
const K = dynamic(() => import('./components/US/K'), { ssr: false });
const L = dynamic(() => import('./components/US/L'), { ssr: false });
const M = dynamic(() => import('./components/US/M'), { ssr: false });

function Page() {
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }
    return (
        <>
            {/* <PDBar /> */}
            <A />
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
            <ForumEntry />
        </>
    );
}

export default Page;
